// @ts-nocheck
import type * as Types from '@lingoda/monolith-graphql/src/generated';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type UserDisplayedWidgetsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UserDisplayedWidgetsQuery = {
    readonly __typename?: 'Query';
    readonly userWidgets: ReadonlyArray<Types.UserDisplayedWidgetClassEnum>;
};

export type DismissUserDisplayedWidgetMutationVariables = Types.Exact<{
    widgetClass: Types.UserDisplayedWidgetClassEnum;
}>;

export type DismissUserDisplayedWidgetMutation = {
    readonly __typename?: 'Mutation';
    readonly dismiss: {
        readonly __typename?: 'MarkWidgetAsDisplayedResultType';
        readonly status: boolean;
    };
};

export type MarkUserWidgetAsDisplayedMutationVariables = Types.Exact<{
    widgetClass: Types.UserDisplayedWidgetClassEnum;
}>;

export type MarkUserWidgetAsDisplayedMutation = {
    readonly __typename?: 'Mutation';
    readonly markWidgetAsDisplayed: {
        readonly __typename?: 'MarkWidgetAsDisplayedResultType';
        readonly status: boolean;
    };
};

export const UserDisplayedWidgetsDocument = gql`
    query UserDisplayedWidgets {
        userWidgets
    }
` as unknown as DocumentNode<UserDisplayedWidgetsQuery, UserDisplayedWidgetsQueryVariables>;
export const DismissUserDisplayedWidgetDocument = gql`
    mutation DismissUserDisplayedWidget($widgetClass: UserDisplayedWidgetClassEnum!) {
        dismiss(widgetClass: $widgetClass) {
            status
        }
    }
` as unknown as DocumentNode<
    DismissUserDisplayedWidgetMutation,
    DismissUserDisplayedWidgetMutationVariables
>;
export const MarkUserWidgetAsDisplayedDocument = gql`
    mutation MarkUserWidgetAsDisplayed($widgetClass: UserDisplayedWidgetClassEnum!) {
        markWidgetAsDisplayed(widgetClass: $widgetClass) {
            status
        }
    }
` as unknown as DocumentNode<
    MarkUserWidgetAsDisplayedMutation,
    MarkUserWidgetAsDisplayedMutationVariables
>;
